import {Component} from '@angular/core';
import {MatDialogRef} from '@angular/material';

@Component({
    selector: 'app-virtual-account-description-pop-up',
    templateUrl: './virtual-account-description-pop-up.component.html',
    styleUrls: ['./virtual-account-description-pop-up.component.css']
})
export class VirtualAccountDescriptionPopUpComponent {

    constructor(private dialogRef: MatDialogRef<VirtualAccountDescriptionPopUpComponent>) {
    }

    public closeDialog(): void {
        this.dialogRef.close();
    }
}
